<!-- 了解详情 -->
<template>
  <div class="main-news">
    <div class="main-content">
      <div class="each-news"
           v-for="(item,index) in newsList"
           :key="index">
        <div class="each-news-l">
          <div class="each-news-date">
            {{item.contentDate}}
          </div>
          <div class="each-news-line-y">
          </div>
          <div class="each-news-type">
            {{item.type}}
          </div>
        </div>
        <div class="each-news-r"
             @click="goDetail(item.id)">
          <div class="each-news-content">
            <div class="each-news-r-l">
              <div class="each-news-img">
                <img alt="" :src="item.contentImgUrl" />
              </div>
            </div>
            <div class="each-news-r-r">
              <div class="each-news-title">
                {{item.contentTitle}}
              </div>
              <div class="each-news-intr">
                {{item.description}}
              </div>
              <div class="each-news-author">
                {{item.contentAuthor}}
              </div>
            </div>
          </div>
          <div class="each-news-line">
          </div>
        </div>
      </div>
      <!-- 新闻end -->
      <div class="block"
           style="float: right;margin-top: 20px;margin-right: 30px; margin-bottom: 20px">
        <el-pagination @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
export default {
  data() {
    return {
      page: 1,                    // 当前页码
      limit: 10,                  // 每页数
      total: 0,                   // 总条数deleteURL
      dataListLoading: false,     // 数据列表，loading状态
      newsList: [
      ],
      hasLogin: false
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getDataList()
    },
    getDataList() {
      var contentColumn = '50'
      if (this.getStorage(this.GLOBAL.TOKEN)) {
        this.hasLogin = true
        contentColumn = '60'
      }
      this.$request.get('/sys/commcontent/list',
        {
          contentPubStatus: '10',
          contentColumn: contentColumn,
          orderBy: '1',
          page: this.page,
          limit: this.limit
        }
      ).then((res, total, code, data) => {
        this.newsList = res.records.map(item => {
          item.contentDate = Vue.filter('formatDateNoTime')(item.contentDate)
          return item
        })

        this.$nextTick(() => {
          var oList = document.querySelectorAll('.each-news-intr');
          console.log(oList)
          // oList.forEach(function(item){
          //     var oHeight = item.offsetHeight;
          //     if((oHeight/18)>3){
          //       item.setAttribute('class',item.getAttribute('class') + ' texter')
          //     }
          // })
        })
        this.total = total
      }).catch(() => { })
    },
    goDetail(id) {
      this.$router.push({
        name: 'news-detail',
        query: {
          newsId: id
        }
      })
    }
  },
  mounted() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.main-news {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  margin-top: 70px;
  min-height: 300px;
}
.main-content {
  font-size: 14px;
  text-align: center;
  // margin-top: 100px;
}
.each-news {
  overflow: hidden;
}
.each-news-l {
  float: left;
  width: 160px;
  position: relative;
  .each-news-line-y {
    position: absolute;
    right: 13px;
    border-left: 1px solid #d3d3d3;
    height: 161px;
  }
  .each-news-date {
    height: 26px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
    background-image: url("../../assets/img/dateTime.png");
    background-size: 100% 100%;
  }
  .each-news-type {
    color: #f00;
    text-align: right;
    padding-right: 20px;
    margin-top: 10px;
  }
}
.each-news-r {
  float: left;
  margin-left: 40px;
  cursor: pointer;
  width: 1000px;
  overflow: hidden;
  .each-news-content {
    overflow: hidden;
  }
  .each-news-r-l {
    float: left;
    .each-news-img {
      img {
        width: 200px;
        height: 120px;
      }
    }
  }
  .each-news-r-r {
    float: left;
    margin-left: 20px;
    text-align: left;
    width: 780px;
    .each-news-title {
      font-size: 18px;
      color: #262626;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: bold;
    }
    .each-news-intr {
      color: #666;
      font-size: 16px;
      margin-top: 12px;
    }
    .each-news-author {
      color: #999;
      margin-top: 20px;
    }

    .texter {
      height: 54px;
      overflow: hidden;
      position: relative;
    }
    .texter::after {
      content: "...";
      position: absolute;
      bottom: 0;
      right: 0;
      padding-left: 4px;
      background: -webkit-linear-gradient(left, #fff 55%);
      background: -o-linear-gradient(right, #fff 55%);
      background: -moz-linear-gradient(right, #fff 55%);
      background: linear-gradient(to right, #fff 55%);
    }
  }
  .each-news-line {
    border-top: 1px solid #d3d3d3;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
